import { getCollectionQueryOptions } from '#pplx/frontend/apps/ask/queries/collection-queries/getCollection.js';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
export function usePrefetchCollection({ collectionSlug, reason, }) {
    const queryClient = useQueryClient();
    return useCallback(() => {
        if (!collectionSlug)
            return;
        const queryOptions = getCollectionQueryOptions({ collectionSlug, reason });
        queryClient.prefetchQuery(queryOptions).then(() => {
            const result = queryClient.getQueryData(queryOptions.queryKey);
            if (result && !result.collection && result.errorCode === undefined) {
                queryClient.resetQueries({ queryKey: queryOptions.queryKey, exact: true });
            }
        });
    }, [collectionSlug, queryClient, reason]);
}
//# sourceMappingURL=usePrefetchCollection.js.map